// extracted by mini-css-extract-plugin
export default {"text":"mv3kHL1smhG3JcD0ADgR","label":"TCdDiZqh700OQyHMlBNC","disabled":"FMHYl5r9wl0hRrX2NNA3","hidden":"fa8NQ22X5oQGDvjP_IvC","input":"kHNz4CTMVxK514cUjqY3"};